import Vue from 'vue';
import Component from 'vue-class-component';
import { BNoticeComponent } from '../../types/vue.types';
import { toastDuration } from '../constants/values';

@Component
export default class InvalidFormMixin extends Vue {

    public invalidFormToast?: BNoticeComponent;

    public showInvalidFormToast() {
        this.invalidFormToast = this.$buefy.toast.open({
            type: 'is-danger',
            duration: toastDuration,
            message: this.$t('common.invalidForm.message').toString(),
        });
    }

    public destroyed() {
        if (this.invalidFormToast) {
            this.invalidFormToast.close();
        }
    }
}
